// Display-only status, distinct from the raw event.status field. Once an
// event's endDate passes but the admin hasn't yet committed/closed it, the
// underlying status field stays 'active' (commit/simulation/zone-edit
// gating throughout the admin UI depends on isClosed staying false until
// that explicit action happens) — this only affects what label is shown.
export function getDisplayStatus(event) {
  if (!event) return 'active';
  if (event.status === 'closed') return 'closed';
  if (new Date(event.endDate) < new Date()) return 'ended';
  return event.status;
}
